export default __webpack_public_path__ + "static/www-9179ff6735b2c55dc516d32e6166f1a4.svg";